/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export interface socialLinksStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
  image: Asset;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
}
export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface sealLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
}
export interface sealImagesStruct {
  image: Asset;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
  alt ? : string;
  sealLink ? : Array < sealLinkStruct > ;
}
export default interface FooterSocial {
  title: string;
  showColumnKiosk ? : boolean;
  showColumnCatalog ? : boolean;
  socialLinks ? : Array < socialLinksStruct > ;
  sealImages ? : Array < sealImagesStruct > ;
  metadata ? : any;
}

export const Props = {
  title: String,
  showColumnKiosk: Boolean,
  showColumnCatalog: Boolean,
  socialLinks: Array as() => Array < socialLinksStruct > ,
  sealImages: Array as() => Array < sealImagesStruct > ,
  metadata: Object,
}

export const WrapperProps = {
  title: String,
  showColumnKiosk: Boolean,
  showColumnCatalog: Boolean,
  socialLinks: Object,
  sealImages: Object,
  metadata: Object,
}

export class FooterSocialBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class FooterSocialInstance implements FooterSocial {
      title: string;
      showColumnKiosk ? : boolean;
      showColumnCatalog ? : boolean;
      socialLinks ? : Array < socialLinksStruct > ;
      sealImages ? : Array < sealImagesStruct > ;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.socialLinks) {
          this.socialLinks = Object.entries(this.socialLinks)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'socialLinks' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.socialLinks.length; i1++) {

            if (this.socialLinks[i1]) {
              if (this.socialLinks[i1].switchable) {
                if (typeof this.socialLinks[i1].switchable.download === 'object') {
                  this.socialLinks[i1].switchable.download = {
                    ...this.socialLinks[i1].switchable.download,
                    link: this.socialLinks[i1].switchable.download['@link'],
                    name: this.socialLinks[i1].switchable.download['@name'],
                    path: this.socialLinks[i1].switchable.download['@path'],
                  };
                } else {
                  this.socialLinks[i1].switchable.download = null as any;
                }
              }
            }
            if (this.socialLinks[i1]) {
              if (typeof this.socialLinks[i1].image === 'object') {
                this.socialLinks[i1].image = {
                  ...this.socialLinks[i1].image,
                  link: this.socialLinks[i1].image['@link'],
                  name: this.socialLinks[i1].image['@name'],
                  path: this.socialLinks[i1].image['@path'],
                };
              } else {
                this.socialLinks[i1].image = null as any;
              }
            }
            if (this.socialLinks[i1]) {
              if (this.socialLinks[i1].mobileAspectRatio) {
                this.socialLinks[i1].mobileAspectRatio = Object.entries(this.socialLinks[i1].mobileAspectRatio)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
              } else {
                this.socialLinks[i1].mobileAspectRatio = null as any;
              }
            }
          }
        } else {
          this.socialLinks = null as any;
        }
        if (this.sealImages) {
          this.sealImages = Object.entries(this.sealImages)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'sealImages' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.sealImages.length; i1++) {
            if (this.sealImages[i1]) {
              if (typeof this.sealImages[i1].image === 'object') {
                this.sealImages[i1].image = {
                  ...this.sealImages[i1].image,
                  link: this.sealImages[i1].image['@link'],
                  name: this.sealImages[i1].image['@name'],
                  path: this.sealImages[i1].image['@path'],
                };
              } else {
                this.sealImages[i1].image = null as any;
              }
            }
            if (this.sealImages[i1]) {
              if (this.sealImages[i1].mobileAspectRatio) {
                this.sealImages[i1].mobileAspectRatio = Object.entries(this.sealImages[i1].mobileAspectRatio)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
              } else {
                this.sealImages[i1].mobileAspectRatio = null as any;
              }
            }
            if (this.sealImages[i1]) {
              if (this.sealImages[i1].sealLink) {
                this.sealImages[i1].sealLink = Object.entries(this.sealImages[i1].sealLink)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'sealLink' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
                for (let i2 = 0; i2 < this.sealImages[i1].sealLink.length; i2++) {

                  if (this.sealImages[i1]) {
                    if (this.sealImages[i1].sealLink[i2]) {
                      if (this.sealImages[i1].sealLink[i2].switchable) {
                        if (typeof this.sealImages[i1].sealLink[i2].switchable.download === 'object') {
                          this.sealImages[i1].sealLink[i2].switchable.download = {
                            ...this.sealImages[i1].sealLink[i2].switchable.download,
                            link: this.sealImages[i1].sealLink[i2].switchable.download['@link'],
                            name: this.sealImages[i1].sealLink[i2].switchable.download['@name'],
                            path: this.sealImages[i1].sealLink[i2].switchable.download['@path'],
                          };
                        } else {
                          this.sealImages[i1].sealLink[i2].switchable.download = null as any;
                        }
                      }
                    }
                  }
                }
              } else {
                this.sealImages[i1].sealLink = null as any;
              }
            }
          }
        } else {
          this.sealImages = null as any;
        }
      }
    }
    return new FooterSocialInstance(props);
  }
}
